import sprite from "../../../assets/icons.svg";

export const SvgIcon = ({
  wrapperClass = "",
  svgClass = "",
  name,
  onClick = () => {},
  title = ""
}) => {
  return (
    <span className={`icon-wrapper ${wrapperClass || " "}`} onClick={onClick} title={title}>
      <svg className={`icon ${svgClass || " "}`}>
        <use href={`${sprite}#${name}`}></use>
      </svg>
    </span>
  );
};
